import { PROFILE_TYPES } from "../constants";

export default ({ get, post, put, checkStatus, toJSON }) => ({
  createUser: () =>
    post("universe/v1/users", { includeClientToken: true })
      .then((response) => checkStatus(response, { disableRedirects: true }))
      .then(toJSON),
  getUser: () => get("universe/v1/users").then(checkStatus).then(toJSON),
  updateUser: (newUserProperties) =>
    put("universe/v1/users", {
      body: newUserProperties,
    })
      .then(checkStatus)
      .then(toJSON),
  adViewed: (adType) => {
    post("universe/v1/users/view_ad", {
      body: {
        adType,
      },
    }).then(checkStatus);
  },
  getGrades: () =>
    get("universe/v1/users/grades").then(checkStatus).then(toJSON),
  validateEmail: (email) =>
    post("universe/v1/users/validate_email", {
      body: {
        email,
      },
    })
      .then(checkStatus)
      .then(toJSON),
  register: (user) =>
    put("universe/v1/users/register", {
      body: {
        email: user.email,
        password: user.password,
        recaptchaToken: user.recaptchaToken,
        classroomsAttributes: [
          {
            classroomType: user.profileType,
            schoolId:
              user.profileType === PROFILE_TYPES.CLASSROOM
                ? user.school.id
                : undefined,
            size:
              user.profileType === PROFILE_TYPES.CLASSROOM
                ? user.numberOfKids
                : undefined,
            name:
              user.profileType === PROFILE_TYPES.CLASSROOM
                ? user.className
                : user.userName,
            gradeId: user.grade.id,
            receiveEmails: user.allowMarketingEmails,
          },
        ],
      },
    })
      .then(checkStatus)
      .then(toJSON),
});
